export const NAME = "projectView";

export const DEFAULT_TAB = "defaultTab";
export const CROWD_CONTENT_TAB = "crowdContentTab";
export const SCHEDULED_ORDERS_TAB = "scheduledOrdersTab";
export const LINKS_TAB = "linksTab";
export const SPECIAL_NOTES_TAB = "specialNotesTab";
